import axios from '@/services/axios';

// 发送验证码
export const sendFontSMSCodeApi = (phone: string) => {
  return axios.post(`/admin/v1/sendFontSMSCode`, { phone });
};

// 手机号是否已存在
// export const checkExistsApi = (phone: string) => {
//   return axios.post(`/aminer-api/bff/api/oauth/phone/checkExists`, {
//     phone: '+86' + phone,
//     client_id: '99ff5e27-a265-46e1-b1fa-c27fb49aeda7',
//   });
// };

// 手机号验证码校验
export const checkSMSCodeApi = (phone: string, sms_code: string) => {
  return axios.post(`/admin/v1/checkSMSCode`, {
    phone: phone,
    sms_code: sms_code,
  });
};

// 用户注册
// export const signUpUserApi = (req: {
//   name: string;
//   phone: string;
//   orgType: number;
//   orgName: string;
//   src: number;
// }) => axios.post(`/admin/v1/signUpUser`, req);

// /admin/v1/getFontMe', //知因
// /admin/v1/setToken', //知因
// /aminer-old-api/magic', // 未绑定用户登录，用户信息

// /aminer-api/api/v0/user/bind', //知因邮箱绑定
// /aminer-api/api/v0/user/bind', // 知因手机绑定
// /aminer-api/api/v0/user/unBind', // 接触绑定
// /admin/v1/signUpUser', // 用户自动注册
// /aminer-api/bff/api/oauth/sendCodeToRegisterLogin', // 用户自动注册
// /aminer-api/bff/api/oauth/login', // 用户自动注册
// /aminer-api/bff/api/oauth/phone/checkExists', // 用户自动注册
// /admin/v1/getOrgByIP', //ip权限

// 获取用户信息
export const getFontMeApi = (params?: any) => axios.post(`/admin/v1/getFontMe`, params);

// setToken
export const setTokenApi = (params?: any) => axios.post(`/admin/v1/setToken`, params);

// setToken
export const magicGetFontMeApi = (params?: any) => axios.post(`/aminer-old-api/magic`, params);

export const bindApi = (params?: any) => axios.post(`/aminer-api/api/v0/user/bind`, params);
export const unBindApi = (params?: any) => axios.post(`/aminer-api/api/v0/user/unBind`, params);
export const signUpUserApi = (params?: any) => axios.post(`/admin/v1/signUpUser`, params);
export const sendCodeToRegisterLoginApi = (params?: any) =>
  axios.post(`/aminer-api/bff/api/oauth/sendCodeToRegisterLogin`, params);
export const oauthLoginApi = (params?: any) =>
  axios.post(`/aminer-api/bff/api/oauth/login`, params);
export const checkExistsApi = (params?: any) =>
  axios.post(`/aminer-api/bff/api/oauth/phone/checkExists`, params);
export const getOrgByIPApi = (params?: any) => axios.post(`/admin/v1/getOrgByIP`, params);
// 根据客户端id 查询机构
export const getOrgByClientID = (params?: any) => axios.post(`/admin/v1/getOrgByClientID`, params);
